// route level code-splitting
// this generates a separate chunk (about.[hash].js) for this route
// which is lazy-loaded when the route is visited.
module.exports = (file) => () => import('@/views/' + file + '.vue')
